import * as React from 'react';
import { useUIFacade } from '../../../../../../../ui/facades/ui.facade';
import DateTemplate from '../../../../../../../ui/templates/columns/DateTemplate';
import LinkTemplate from '../../../../../../../ui/templates/columns/LinkTemplate';
import ValueTemplate from '../../../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../../../ui/widgets/custom/PrwcDataTableAdvanced';

const WorkflowList = (props: any) => {

  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteWorkflow);
  }

  const deleteWorkflow = (rowData: any) => {
    console.log('delete Workflow  --');
    console.log(rowData);
  }

  const editWorkflow = (rowData: any) => {
    console.log('edit Workflow  ---');
    console.log(rowData);
    onEdit(rowData);
  }

  const data = [
    {
      id: 1000,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1001,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1002,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1003,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1004,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1005,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1006,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1007,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1008,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1009,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1010,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1011,
      name: "Workflow_One",
      abbreviation: "WORK",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    }
  ];

  const dataTable = {
    columns: [
      {
        field: "id",
        headerLabelKey: "userCategories.label.workflowId",
        bodyTemplate: LinkTemplate,
        className: "w-10 text-xs",
        sortable: true,
        command: (rowData: any) => {
          editWorkflow(rowData);
        }
      },
      {
        field: "name",
        headerLabelKey: "userCategories.label.workflowName",
        bodyTemplate: ValueTemplate,
        className: "w-20 text-xs",
        sortable: true
      },
      {
        field: "abbreviation",
        headerLabelKey: "userCategories.label.abbreviation",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "lastUpdated",
        headerLabelKey: "userCategories.label.lastUpdated",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "description",
        headerLabelKey: "userCategories.label.description",
        bodyTemplate: ValueTemplate,
        className: "w-32 text-xs",
        sortable: true
      }
    ]
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editWorkflow}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default WorkflowList;
